import { post } from '../service/request'

/**
 * 园区动态
 * @param parkType  1 园区新闻列表  2 园区公告 3 科技政策列表
 * @param {Number} page
 * @param  {Number} limit
 * @return {Promise}
 */
export const getYQDTList = (parkType = 1, page = 1, limit = 10) => {
	let params = {
		parksCode: '001001',
		//	typeId: '201',
		pageNum: page,
		pageSize: limit,
	}
	let url = ''
	switch (parkType) {
		case 1:
			params.typeId = 100
			url = '/kxZxNews/list'
			break
		case 2:
			params.parksCode = '001001'
			url = '/zxNotice/list'
			break
		case 3:
			params.typeId = 201
			url = '/kxZxPolicy/list'
			break
	}

	return post(url, params)
}

/**
 * 园区动态-
 * @return {Promise}
 * @param parkType
 * @param id
 */
export const getYQDTDetail = (parkType = 1, id = '') => {
	let url = ''
	switch (parkType) {
		case 1:
			url = '/kxZxNews/detail'
			break
		case 2:
			url = '/zxNotice/detail'
			break
		case 3:
			url = '/kxZxPolicy/detail'
			break
	}
	return post(url, { id })
}
